module.exports = __webpack_public_path__ + "img/advisor5.40cca6c2.png";